import { Stack } from '@chakra-ui/react';
import { useAppContext, useGifts } from '@frx/frx-react-context';
import { DonationProps, DonorMessageProps, Wrapper } from '../../components';
import {
  DonationsMainColumn,
  DonorMessages,
  FacebookFundraiser,
} from './columns';
import { useEventId } from '../../hooks';
import { getDonationTime } from '../../utils';

export const Donations = () => {
  const {
    data: {
      authData: { user },
    },
  } = useAppContext();

  const { data: giftsList, isInitialLoading: isGiftsLoading } = useGifts({
    cons_id: user?.cons_id as number,
    fr_id: useEventId(),
    list_page_size: 500,
    list_sort_column: 'date_recorded',
    list_ascending: false,
  });

  const gifts = giftsList?.gift || [];

  const donations: DonationProps[] = gifts?.map((gift: any) => ({
    name: gift.recognitionName ?? `${gift.name.first} ${gift.name.last}`,
    giftId: gift.id,
    contactId: gift.contactId,
    email: gift.email,
    amount: gift.giftAmount,
    date: gift.date,
    thanked: gift.acknowledged,
  }));

  const donorMessages: DonorMessageProps[] = gifts
    ?.filter((gift) => gift.giftMessage)
    .map((g) => ({
      giftId: g.id,
      name: g.recognitionName ?? `${g.name.first} ${g.name.last}`,
      age: `${getDonationTime(g.date)} ago`,
      message: g.giftMessage,
    }));

  return (
    <Stack
      direction={['column', 'column', 'column', 'row']}
      spacing={[0, 0, 6]}
    >
      <Wrapper>
        <DonationsMainColumn donations={donations} isLoading={isGiftsLoading} />
      </Wrapper>
      <Wrapper>
        {donorMessages.length && (
          <DonorMessages
            donorMessages={donorMessages}
            isLoading={isGiftsLoading}
          />
        )}
        <FacebookFundraiser />
      </Wrapper>
    </Stack>
  );
};
